module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_112_15.c04c84dd.pdf";